module.exports = __webpack_public_path__ + "img/39_10.b675ce0e.png";